import apiAthlete from '@/api/athlete'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  activateAthleteStart: '[activate athlete] activate athlete start',
  activateAthleteSuccess: '[activate athlete] activate athlete success',
  activateAthleteFailure: '[activate athlete] activate athlete failure'
}

export const actionTypes = {
  activateAthlete: '[activate athlete] activate athlete'
}

const mutations = {
  [mutationTypes.activateAthleteStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.activateAthleteSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.activateAthleteFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.activateAthlete](context, {athleteId, params}) {
    context.commit(mutationTypes.activateAthleteStart)
    return new Promise(resolve => {
      apiAthlete
        .activateAthlete(athleteId, params)
        .then(response => {
          context.commit(mutationTypes.activateAthleteSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.activateAthleteFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
